module.exports = __webpack_public_path__ + "img/loading.ef6bf0de.png";